import { AspAccountAssignmentRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspAccountAssignment() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);

  // Called once per Type ('receivables' | 'payables') — callers keep the returned Account
  async function fetchAspAccountAssignment(params: AspAccountAssignmentRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspAccountAssignment(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchAspAccountAssignment };
}
